const updateAboutLayout = (layout) => {
    const left = layout.querySelector(".about-layout__left");
    const right = layout.querySelector(".about-layout__right"); 

    if (!left || !right) {
        return;
    }

    console.log("hello world");
    console.log(left.scrollHeight);
    console.log(right.scrollHeight);

    layout.classList.toggle(
        "is-left-taller",
        left.scrollHeight > right.scrollHeight
    );
};

export const initAboutLayouts = () => {
    document.querySelectorAll(".about-layout").forEach((layout) => {
        const observer = new ResizeObserver(() => {
            updateAboutLayout(layout);
        });

        observer.observe(layout);
        updateAboutLayout(layout);
    });
};